module.exports = __webpack_public_path__ + "media/images/flags/64/Iceland-412146b9a7e591c0c19188a3997f9c88.png";